import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TopBar from "./TopBar";
import Sidebar from "./Sidebar";
import { retrieveFromLocal } from "../helper/localStore";

interface BaseLayoutProps {
  children: ReactNode;
}

const BaseLayout: React.FC<BaseLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const token = retrieveFromLocal("token");
  const user: any = retrieveFromLocal("user");

  React.useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <Box height={"100vh"} overflow={"hidden"}>
      <TopBar />
      <Box sx={{ width: "100%", height: "90vh", display: "flex" }}>
        {!user && <Sidebar />}
        <Box
          width={!user ? "90%" : "100%"}
          height={"90vh"}
          overflow={"auto"}
          pb={5}
          px={5}
          bgcolor={"#f8f8f8"}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default BaseLayout;
